var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loadingBox,
              expression: "loadingBox",
            },
          ],
          staticClass: "card-box",
        },
        [
          _c(
            "div",
            {
              staticClass: "acea-row row-between row-middle card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                [
                  _c(
                    "el-tabs",
                    {
                      on: { "tab-click": _vm.handleClick },
                      model: {
                        value: _vm.activeName,
                        callback: function ($$v) {
                          _vm.activeName = $$v
                        },
                        expression: "activeName",
                      },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "添加客户", name: "1" } },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v(" 添加客户 ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "添加合同", name: "2" } },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v(" 添加合同 ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "添加联系人", name: "3" } },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _vm._v(
                                "\n              添加联系人\n              "
                              ),
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    content: "列表支持拖动排序",
                                    placement: "top-start",
                                    trigger: "hover",
                                    width: "200",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "iconfont iconshuoming",
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    { attrs: { size: "small" }, on: { click: _vm.addGroup } },
                    [_vm._v("新增分组")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        loading: _vm.loading,
                        size: "small",
                        type: "primary",
                      },
                      on: { click: _vm.submitFrom },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.dataList, function (item, index1) {
            return _c(
              "div",
              { key: index1, staticClass: "wrapper-item" },
              [
                _c("div", { staticClass: "flex-center bgcColor" }, [
                  _c("div", { staticClass: "headerLeft" }, [
                    _c("span", [_vm._v(_vm._s(item.title))]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "headerRight" },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: "显示隐藏分组",
                            effect: "dark",
                            placement: "top",
                          },
                        },
                        [
                          item.status == 0
                            ? _c("span", {
                                staticClass: "iconfont iconyincang pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.showCate(item)
                                  },
                                },
                              })
                            : _c("span", {
                                staticClass: "iconfont icondakai pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.showCate(item)
                                  },
                                },
                              }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: "编辑",
                            effect: "dark",
                            placement: "top",
                          },
                        },
                        [
                          _c("span", {
                            staticClass: "iconfont iconbianji1 pointer",
                            on: {
                              click: function ($event) {
                                return _vm.editCate(item)
                              },
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      item.enable_delete == 1
                        ? [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: "删除",
                                  effect: "dark",
                                  placement: "top",
                                },
                              },
                              [
                                _c("span", {
                                  staticClass: "iconfont iconshanchu pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteCate(item.id)
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    ref: "table",
                    refInFor: true,
                    staticClass: "table",
                    staticStyle: { width: "100%" },
                    attrs: { data: item.data, "row-key": "id" },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        fixed: "left",
                        label: "字段名称",
                        "min-width": "130px",
                        prop: "id",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-input", {
                                  staticClass: "input",
                                  attrs: {
                                    placeholder: "请输入",
                                    size: "small",
                                  },
                                  model: {
                                    value: scope.row.key_name,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "key_name", $$v)
                                    },
                                    expression: "scope.row.key_name",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "字段类型",
                        "min-width": "130px",
                        prop: "type",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      disabled: scope.row.enable_delete !== 1,
                                      size: "small",
                                    },
                                    model: {
                                      value: scope.row.type,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "type", $$v)
                                      },
                                      expression: "scope.row.type",
                                    },
                                  },
                                  _vm._l(_vm.typeOptions, function (item) {
                                    return _c("el-option", {
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "关联字典",
                        "min-width": "150px",
                        prop: "cate_id",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      disabled:
                                        scope.row.enable_delete !== 1 ||
                                        _vm.typeDisabled.includes(
                                          scope.row.type
                                        ),
                                      clearable: "",
                                      filterable: "",
                                      placeholder: "请选择关联字典",
                                      size: "small",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.getDictData(
                                          scope.row.dict_ident,
                                          index1,
                                          scope.$index
                                        )
                                      },
                                    },
                                    model: {
                                      value: scope.row.dict_ident,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "dict_ident", $$v)
                                      },
                                      expression: "scope.row.dict_ident",
                                    },
                                  },
                                  _vm._l(_vm.dictList, function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.ident,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "是否必填", prop: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-switch", {
                                  attrs: {
                                    "active-value": 1,
                                    "inactive-value": 0,
                                    "active-text": "必填",
                                    "inactive-text": "选填",
                                  },
                                  model: {
                                    value: scope.row.required,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "required", $$v)
                                    },
                                    expression: "scope.row.required",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "唯一校验", prop: "uniqued" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c("el-switch", {
                                  attrs: {
                                    "active-value": 1,
                                    disabled: _vm.contractList.includes(
                                      row.key
                                    ),
                                    "inactive-value": 0,
                                    "active-text": "唯一",
                                    "inactive-text": "重复",
                                  },
                                  model: {
                                    value: row.uniqued,
                                    callback: function ($$v) {
                                      _vm.$set(row, "uniqued", $$v)
                                    },
                                    expression: "row.uniqued",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "提示信息",
                        "min-width": "110px",
                        prop: "placeholder",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c("el-input", {
                                  staticClass: "input",
                                  attrs: {
                                    placeholder: "请输入",
                                    size: "small",
                                  },
                                  model: {
                                    value: row.placeholder,
                                    callback: function ($$v) {
                                      _vm.$set(row, "placeholder", $$v)
                                    },
                                    expression: "row.placeholder",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "默认值",
                        "min-width": "180px",
                        prop: "value",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _vm.getTypes(
                                  row.type,
                                  "select",
                                  "radio",
                                  "checked"
                                )
                                  ? _c("el-input", {
                                      staticClass: "input",
                                      attrs: {
                                        disabled:
                                          row.type == "file" ||
                                          row.type == "images",
                                        placeholder: "请输入默认值",
                                        size: "small",
                                      },
                                      model: {
                                        value: row.value,
                                        callback: function ($$v) {
                                          _vm.$set(row, "value", $$v)
                                        },
                                        expression: "row.value",
                                      },
                                    })
                                  : row.type == "radio"
                                  ? _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "请选择默认值",
                                          size: "small",
                                        },
                                        model: {
                                          value: row.value,
                                          callback: function ($$v) {
                                            _vm.$set(row, "value", $$v)
                                          },
                                          expression: "row.value",
                                        },
                                      },
                                      _vm._l(row.optionItems, function (el) {
                                        return _c("el-option", {
                                          key: el.value,
                                          attrs: {
                                            label: el.name,
                                            value: el.value,
                                          },
                                        })
                                      }),
                                      1
                                    )
                                  : _c("el-cascader", {
                                      attrs: {
                                        disabled: row.key == "customer_label",
                                        options: row.optionItems,
                                        props: {
                                          checkStrictly: false,
                                          label: "name",
                                          value: "value",
                                          multiple:
                                            row.type == "single" ||
                                            row.type == "radio"
                                              ? false
                                              : true,
                                        },
                                        clearable: "",
                                        "collapse-tags": "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.changeCascader(
                                            row.value,
                                            index1,
                                            _vm.scope.$index
                                          )
                                        },
                                      },
                                      model: {
                                        value: row.value,
                                        callback: function ($$v) {
                                          _vm.$set(row, "value", $$v)
                                        },
                                        expression: "row.value",
                                      },
                                    }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { "min-width": "380" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      placement: "top",
                                      trigger: "hover",
                                      width: "300",
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "tips-popover" }, [
                                      _vm._v(
                                        "\n                文本框、文本域的边界值为字数限制；"
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "\n                数字的边界值为数值范围；"
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "\n                下拉复选、复选按钮的边界值为选中数量；"
                                      ),
                                      _c("br"),
                                      _vm._v("日期控件的边界值为时间范围"),
                                      _c("br"),
                                      _vm._v(
                                        "\n                图片选择控件、附件控件的边界值为上传数量。\n              "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "reference" },
                                        slot: "reference",
                                      },
                                      [
                                        _vm._v("边界值 "),
                                        _c("span", {
                                          staticClass: "el-icon-info",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.type !== "date"
                                  ? _c(
                                      "div",
                                      { staticClass: "flex" },
                                      [
                                        _c("el-input-number", {
                                          staticStyle: { width: "130px" },
                                          attrs: {
                                            disabled:
                                              _vm.maxDisabledList.includes(
                                                scope.row.key
                                              ) ||
                                              scope.row.type === "oaWangeditor",
                                            max: 99999999,
                                            min: 1,
                                            "controls-position": "right",
                                            size: "small",
                                          },
                                          model: {
                                            value: scope.row.min,
                                            callback: function ($$v) {
                                              _vm.$set(scope.row, "min", $$v)
                                            },
                                            expression: "scope.row.min",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "m5" }, [
                                          _vm._v(" - "),
                                        ]),
                                        _vm._v(" "),
                                        _c("el-input-number", {
                                          staticStyle: { width: "130px" },
                                          attrs: {
                                            disabled:
                                              _vm.maxDisabledList.includes(
                                                scope.row.key
                                              ) ||
                                              scope.row.type === "oaWangeditor",
                                            max: 99999999,
                                            min: 1,
                                            "controls-position": "right",
                                            size: "small",
                                          },
                                          model: {
                                            value: scope.row.max,
                                            callback: function ($$v) {
                                              _vm.$set(scope.row, "max", $$v)
                                            },
                                            expression: "scope.row.max",
                                          },
                                        }),
                                        _vm._v(" "),
                                        scope.row.type == "number"
                                          ? _c("el-input-number", {
                                              staticStyle: {
                                                width: "100px",
                                                "margin-left": "5px",
                                              },
                                              attrs: {
                                                min: 0,
                                                max: 10,
                                                "controls-position": "right",
                                                size: "small",
                                              },
                                              model: {
                                                value: scope.row.decimal_place,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "decimal_place",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.decimal_place",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      { staticClass: "flex" },
                                      [
                                        _c("el-date-picker", {
                                          staticStyle: { width: "130px" },
                                          attrs: {
                                            format: "yyyy-MM-dd",
                                            "value-format": "yyyy-MM-dd",
                                            clearable: "",
                                            placeholder: "请选择",
                                            size: "small",
                                            type: "date",
                                          },
                                          model: {
                                            value: scope.row.min,
                                            callback: function ($$v) {
                                              _vm.$set(scope.row, "min", $$v)
                                            },
                                            expression: "scope.row.min",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "m5" }, [
                                          _vm._v(" - "),
                                        ]),
                                        _vm._v(" "),
                                        _c("el-date-picker", {
                                          staticStyle: { width: "130px" },
                                          attrs: {
                                            format: "yyyy-MM-dd",
                                            "value-format": "yyyy-MM-dd",
                                            clearable: "",
                                            placeholder: "请选择",
                                            size: "small",
                                            type: "date",
                                          },
                                          model: {
                                            value: scope.row.max,
                                            callback: function ($$v) {
                                              _vm.$set(scope.row, "max", $$v)
                                            },
                                            expression: "scope.row.max",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "状态", prop: "status" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c("el-switch", {
                                  attrs: {
                                    "active-value": 1,
                                    disabled: row.enable_delete !== 1,
                                    "inactive-value": 0,
                                    "active-text": "启用",
                                    "inactive-text": "停用",
                                  },
                                  model: {
                                    value: row.status,
                                    callback: function ($$v) {
                                      _vm.$set(row, "status", $$v)
                                    },
                                    expression: "row.status",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        fixed: "right",
                        label: "操作",
                        "min-width": "150px",
                        prop: "address",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.moveFn(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("移动分组")]
                                ),
                                _vm._v(" "),
                                scope.row.enable_delete == 1
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteFn(scope, index1)
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "add-row" }, [
                  _c(
                    "span",
                    {
                      staticClass: "pointer",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.addANewLine(index1)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "el-icon-plus mr5" }),
                      _vm._v("添加字段"),
                    ]
                  ),
                ]),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("oaDialog", {
        ref: "oaDialog",
        attrs: {
          formConfig: _vm.formConfig,
          formDataInit: _vm.formDataInit,
          formRules: _vm.formRules,
          fromData: _vm.fromData,
        },
        on: { submit: _vm.submit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }